// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ws-border-allow input{\n    border-color: green !important;\n}\n.ws-border-deny input{\n    border-color: red!important;\n}\n.ws-border-allow-before  div{\n    border-color: green !important;\n    margin: -1px !important;\n    padding-left: 3px;\n}\n.ws-border-deny-before  div{\n    border-color: red!important;\n    margin: -1px !important;\n    padding-left: 3px;\n}\n.ws-select span{\n    font-size:25px\n}\n.ws-small-info{\n    margin-left: 92px;\n}", ""]);
// Exports
module.exports = exports;
